import { Button, Form, message, Modal, notification } from "antd";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { closeModal } from "store/slices/modalsSlice";
import CategorieForm from "./Supplement-Form";
import useSubscriptionCategories from "hooks/useSubscriptionCategories";

const NewCategorieModal = () => {
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const { isModalOpen, modalType, modalProps } = useSelector(
    (state) => state.modals
  );
  const { addCategory, Categorie, setCategories, isLoading, error, setError } =
    useSubscriptionCategories();
  const [isSendForAdd, setIsSendForAdd] = useState(false);
  useEffect(() => {
    if (isSendForAdd) {
      if (error) {
        message.error(t("employees.crud.form.error.add") + " " + error);
      } else {
        message.success(t("categorie.crud.form.add.success"));
        onClose();
      }
      setIsSendForAdd(false);
    }
  }, [isSendForAdd, error]);
  const open = isModalOpen && modalType === "new_categorie";

  const onSubmit = async (values) => {
    try {
      await addCategory(values);
      // ✅ Ajouter après succès
      dispatch({ type: "categories/refresh" });
    } catch (error) {
      notification.error({
        message: t("employees.crud.form.error.add"),
        description: error,
        role: "alert",
        duration: 3,
      });
    } finally {
      setIsSendForAdd(true);
    }
  };

  const onClose = () => {
    form.resetFields();
    dispatch(closeModal());
  };
  return (
    <Modal
      title={
        <h4
          style={{
            textAlign: "center",
            fontSize: "20px",
            fontWeight: "bold",
            color: "#333",
            marginBottom: 0,
          }}
        >
          {t("categorieAbb.crud.form")}
        </h4>
      }
      open={open}
      onCancel={onClose}
      destroyOnClose
      footer={[
        <div
          key="footer-buttons"
          style={{
            display: "flex",
            justifyContent: "flex-end", // Aligner les boutons à droite
            gap: "12px", // Espacement entre les boutons
            padding: "12px 0",
          }}
        >
          <Button
            key="cancel"
            onClick={onClose}
            className="custom-btn-1"
            style={{
              maxWidth: "100%",
              backgroundColor: "#f5f5f5",
              color: "#555",
              borderRadius: "50px", // Arrondi plus élégant
              padding: "12px 24px", // Plus d'espace pour un meilleur équilibre
              border: "1px solid #ddd",
              fontWeight: "bold",
              cursor: "pointer",
              display: "flex",
              alignItems: "center", // Centre verticalement
              justifyContent: "center", // Centre horizontalement
              minWidth: "120px", // Évite que le bouton soit trop petit
              textAlign: "center",
              transition: "all 0.3s ease-in-out",
            }}
          >
            {t("employees.crud.form.button.cancel")}
          </Button>
          <Button
            key="submit"
            type="primary"
            htmlType="submit"
            form="Categorie_Form"
            disabled={isLoading}
            className="custom-btn-2"
            style={{
              borderRadius: "50px",
              padding: "12px 24px",
              border: "none",
              backgroundColor: "#1890ff",
              color: "#fff",
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              minWidth: "120px",
              textAlign: "center",
              transition: "all 0.3s ease-in-out",

              fontWeight: "bold",
            }}
          >
            {t("employees.crud.form.button.save")}
          </Button>
        </div>,
      ]}
      centered={true}
      styles={{
        content: {
          overflowY: "auto",
          maxHeight: "75vh",
          borderRadius: "12px",
          padding: "20px",
          boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
          backgroundColor: "rgba(255, 255, 255, 0.95)",
        },
      }}
    >
      <CategorieForm form={form} onSubmit={onSubmit} />
    </Modal>
  );
};

export default NewCategorieModal;
